angular
  .module 'bookAndPay'
  .directive 'appHeader', ->
    restrict: 'EA'
    template: require('templates/book_and_pay/header.html.slim')
    controller: ($scope, DataService) ->
      $scope.data = DataService
